export async function startClockIn(api) {
  const { data: data } = await api.post(`start-clock-in`);
  return { data };
}

export async function endClockIn(api) {
  const { data: data } = await api.post(`end-clock-in`);
  return { data };
}

export async function startBreak(api) {
  const { data: data } = await api.post(`start-break`);
  return { data };
}

export async function endBreak(api) {
  const { data: data } = await api.post(`end-break`);
  return { data };
}

export async function startPrivateExit(api) {
  const { data: data } = await api.post(`start-private-exit`);
  return { data };
}

export async function endPrivateExit(api) {
  const { data: data } = await api.post(`end-private-exit`);
  return { data };
}

export async function startFieldWork(api) {
  const { data: data } = await api.post(`start-field-work`);
  return { data };
}

export async function endFieldWork(api) {
  const { data: data } = await api.post(`end-field-work`);
  return { data };
}

export async function myCurrentPresence(api) {
  const { data: data } = await api.get(`my-presence-current-presence`);
  return { data };
}

export async function myPresenceHistory(api, params) {
  let url = "my-presence-history";

  // Check if params has value and if there are any parameters in it (params is an object)
  if (params && Object.keys(params).length > 0) {
    url += "?";

    // Iterate through the object properties and construct the URL
    for (const key in params) {
      if (params.hasOwnProperty(key) && params[key] !== "") {
        url += `${key}=${params[key]}&`;
      }
    }

    // Remove the trailing '&' character
    url = url.slice(0, -1);
  }

  //console.log(url);
  const { data: data } = await api.get(url);
  return { data };
}

export async function myPersonalPresenceHistory(api, date, userId) {
  let url = `my-personal-presence-history?date=${date}${
    userId ? "&user_id=" + userId : ""
  }`;
  const { data: data } = await api.post(url);
  return { data };
}

export async function givenDayWeek(api) {
  const { data: data } = await api.get(`my-presence-given-day-week`);
  return { data };
}
export async function allWeeks(api) {
  const { data: data } = await api.get(`my-presence-all-weeks`);
  return { data };
}
export async function currentWeek(api, yearAndWeek) {
  if (!yearAndWeek) {
    const { data: data } = await api.get(`my-presence-current-week`);
    return { data };
  } else {
    const { data: data } = await api.get(
      `my-presence-current-week?weeknum=${yearAndWeek}`
    );
    return { data };
  }
}
export async function weeklyDates(api, yearAndWeek) {
  let url = `my-presence-weekly-dates`;
  if (yearAndWeek) {
    url += `?weeknum=${yearAndWeek}`;
  }
  const { data: data } = await api.get(url);
  return { data };
}

export async function dayTotals(api) {
  const { data: data } = await api.get(`my-presence-day-totals`);
  return { data };
}
export async function getTotals(api, yearAndWeek) {
  if (!yearAndWeek) {
    const { data: data } = await api.get(`my-presence-get-totals`);
    return { data };
  } else {
    const { data: data } = await api.get(
      `my-presence-get-totals?weeknum=${yearAndWeek}`
    );
    return { data };
  }
}

export async function getWeekTotals(api, yearAndWeek) {
  if (!yearAndWeek) {
    const { data: data } = await api.get(`my-presence-week-totals`);
    return { data };
  } else {
    const { data: data } = await api.get(
      `my-presence-week-totals?weeknum=${yearAndWeek}`
    );
    return { data };
  }
}

export async function setGetPresenceComment(api, commentData) {
  const { data: data } = await api.post(
    `set-get-presence-comment`,
    commentData
  );
  return { data };
}
